import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    fetchOts: ['query', 'callback'],
    fetchOtsSuccess: ['items', 'pagination'],
    fetchOtsFailure: ['error'],

    fetchFlatOts: ['query', 'callback'],
    fetchFlatOtsSuccess: ['items'],
    fetchFlatOtsFailure: ['error'],

    resetCreatedOt: null,

    createOt: ['ot', 'query'],
    createOtSuccess: ['ot'],
    createOtFailure: ['error'],

    fetchOt: ['ot_uuid', 'query'],
    fetchOtSuccess: ['ot'],
    fetchOtFailure: ['error'],

    updateOt: ['ot_uuid', 'ot', 'query'],
    updateOtSuccess: ['ot', 'ot_details'],
    updateOtFailure: ['error'],

    deleteOt: ['ot_uuid', 'query'],
    deleteOtSuccess: ['items'],
    deleteOtFailure: ['error'],

    fetchOtDetails: ['ot_uuid', 'query', 'callback'],
    fetchOtDetailsSuccess: ['details', 'total', 'ot_details'],
    fetchOtDetailsFailure: ['error'],

    createOtDetail: ['ot_uuid', 'detail', 'query'],
    createOtDetailSuccess: ['detail', 'ot_details'],
    createOtDetailFailure: ['error'],

    updateOtDetail: ['uuid', 'detail', 'query', 'ot_uuid'],
    updateOtDetailSuccess: ['detail', 'ot_details'],
    updateOtDetailFailure: ['error'],

    deleteOtDetail: ['detail_uuid', 'ot_uuid', 'query'],
    deleteOtDetailSuccess: ['ot_details'],
    deleteOtDetailFailure: ['error'],

    /** Ot transactions */
    fetchOtTransactions: ['ot_uuid', 'query', 'callback'],
    fetchOtTransactionsSuccess: ['transactions', 'total'],
    fetchOtTransactionsFailure: ['error'],

    createOtTransaction: ['ot_uuid', 'transaction', 'query'],
    createOtTransactionSuccess: ['transaction', 'transactions'],
    createOtTransactionFailure: ['error'],

    deleteOtTransaction: ['transaction_id', 'ot_uuid', 'query'],
    deleteOtTransactionSuccess: null,
    deleteOtTransactionFailure: ['error'],

    /** Ot assets */
    fetchOtAssets: ['ot_uuid', 'query', 'callback'],
    fetchOtAssetsSuccess: ['assets'],
    fetchOtAssetsFailure: ['error'],

    createOtAsset: ['ot_uuid', 'asset', 'query'],
    createOtAssetSuccess: ['asset'],
    createOtAssetFailure: ['error'],

    deleteOtAsset: ['asset_id', 'ot_uuid', 'query'],
    deleteOtAssetSuccess: null,
    deleteOtAssetFailure: ['error'],

    createQuote: ['quote', 'query'],
    createQuoteSuccess: ['quote'],
    createQuoteFailure: ['error'],

    notify: ['ot_uuid', 'message'],
    notifySuccess: null,
    notifyFailure: ['error'],

    /** Ot discounts */
    fetchOtDiscounts: ['ot_uuid', 'query', 'callback'],
    fetchOtDiscountsSuccess: ['discounts', 'total'],
    fetchOtDiscountsFailure: ['error'],

    createOtDiscount: ['ot_uuid', 'discount', 'query'],
    createOtDiscountSuccess: ['discount', 'discounts'],
    createOtDiscountFailure: ['error'],

    deleteOtDiscount: ['discount_id', 'ot_uuid', 'query'],
    deleteOtDiscountSuccess: null,
    deleteOtDiscountFailure: ['error'],

    /** OT attributes */
    fetchOtAttributes: ['ot_uuid', 'query', 'callback'],
    fetchOtAttributesSuccess: ['attributes'],
    fetchOtAttributesFailure: ['error'],

    createOtAttribute: ['ot_uuid', 'attribute', 'query', 'onFinish'],
    createOtAttributeSuccess: ['attribute', 'attributes'],
    createOtAttributeFailure: ['error'],

    deleteOtAttribute: ['attribute_id', 'ot_uuid'],
    deleteOtAttributeSuccess: null,
    deleteOtAttributeFailure: ['error'],

    createQuickQuote: ['data', 'onSuccess'],
    createQuickQuoteSuccess: ['quote'],
    createQuickQuoteFailure: ['error'],

    createQuickOt: ['data', 'onSuccess'],
    createQuickOtSuccess: ['ot'],
    createQuickOtFailure: ['error'],

    resetCreatedQuote: null,
    resetCreatedOt: null,

    // Confirm quote to create a new ot
    confirmQuote: ['ot_uuid'],
    confirmQuoteFailure: ['error'],
});


export const OtTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    loading: false,
    error: null,
    items: [],
    details: [],
    transactions: [],
    discounts: [],
    assets: [],
    detailsTotal: 0,
    transactionsTotal: 0,
    discountsTotal: 0,
    ot: null,
    otCreated: null,
    otUpdated: null,
    otDeleted: null,
    otToEdit: null,
    otDetailCreated: null,
    otTransactionCreated: null,
    pagination: null,
    lastSyncDt: null,
    lastNotifiedDt: null,
    createdOtDt: null,
    otDetailUpdated: null,
    attributes: [],
    otUpdatedDt: null,
    otAttributeCreated: null,

    createdQuote: null,
    createdOt: null,
    flat_ots:[],
    ot_details: {},
})

const resetState = () => INITIAL_STATE;

export const reducer = createReducer(INITIAL_STATE, {

    // Fetch work order actions
    [Types.FETCH_OTS]: (state) => {
        return {
            ...state,
            loading: true,
            error: null,
            items: [],
            otToEdit: null,
        };
    },

    [Types.FETCH_OTS_SUCCESS]: (state, {items, pagination}) => {
        return {
            ...state,
            items,
            pagination,
            loading: false,
            error: null,
            otToEdit: null,
            lastSyncDt: new Date().getTime(),
        };
    },

    [Types.FETCH_OTS_FAILURE]: (state, action) => {
        return {
            ...state,
            loading: false,
            error: action.error,
            items: [],
            otToEdit: null,
        };
    },

    // Fetch work order actions
    [Types.FETCH_FLAT_OTS]: (state) => {
        return {
            ...state,
            loading: true,
            error: null,
            flat_ots: [],
        };
    },

    [Types.FETCH_FLAT_OTS_SUCCESS]: (state, {items, pagination}) => {
        return {
            ...state,
            flat_ots: items,
            loading: false,
            error: null,
        };
    },

    [Types.FETCH_FLAT_OTS_FAILURE]: (state, action) => {
        return {
            ...state,
            loading: false,
            error: action.error,
            flat_ots: [],
        };
    },

    // Reset created ot
    [Types.RESET_CREATED_OT]: (state) => {
        return {
            ...state,
            loading: false,
            error: null,
            otCreated: null,
        };
    },

    // Create an work order
    [Types.CREATE_OT]: (state, action) => {
        return {
            ...state,
            loading: true,
            error: null,
            otToEdit: null,
            otCreated: null,
        };
    },

    [Types.CREATE_OT_SUCCESS]: (state, { ot }) => {
        return {
            ...state,
            loading: false,
            otCreated: ot,
            error: null,
            otToEdit: null,
        };
    },

    [Types.CREATE_OT_FAILURE]: (state, action) => {
        return {
            ...state,
            loading: false,
            error: action.error,
            ot: null,
            otToEdit: null,
            otCreated: null,
        };
    },

    // Fetch a single work order
    [Types.FETCH_OT]: (state) => {
        return {
            ...state,
            loading: true,
            error: null,
            otToEdit: null,
        };
    },

    [Types.FETCH_OT_SUCCESS]: (state, { ot }) => {
        return {
            ...state,
            loading: false,
            error: null,
            otToEdit: ot,
        };
    },

    [Types.FETCH_OT_FAILURE]: (state, action) => {
        return {
            ...state,
            loading: false,
            error: action.error,
            ot: null,
            otToEdit: null,
        };
    },

    // Update an work order
    [Types.UPDATE_OT]: (state, action) => {
        return {
            ...state,
            loading: true,
            error: null,
            ot: null,
            otUpdated: null,
        };
    },

    [Types.UPDATE_OT_SUCCESS]: (state, {ot, ot_details}) => {
        return {
            ...state,
            loading: false,
            otToEdit: ot,
            error: null,
            lastSyncDt: new Date().getTime(),
            ot_details,
        };
    },

    [Types.UPDATE_OT_FAILURE]: (state, action) => {
        return {
            ...state,
            loading: false,
            error: action.error,
        };
    },

    // Delete an existing work order
    [Types.DELETE_OT]: (state) => {
        return {
            ...state,
            loading: true,
            otDeleted: null,
            itemsWithFlags: [],
            error: null,
        };
    },

    [Types.DELETE_OT_SUCCESS]: (state, action) => {
        return {
            ...state,
            loading: false,
            otDeleted: true,
            error: null,
        };
    },

    [Types.DELETE_OT_FAILURE]: (state, action) => {
        return {
            ...state,
            loading: false,
            otDeleted: null,
            error: action.error,
        };
    },

    // Fetch work order actions
    [Types.FETCH_OT_DETAILS]: (state) => {
        return {
            ...state,
            loading: true,
            error: null,
            details: [],
        };
    },

    [Types.FETCH_OT_DETAILS_SUCCESS]: (state, {details, total, ot_details}) => {
        console.log('FETCH_OT_DETAILS_SUCCESS', ot_details)
        return {
            ...state,
            details,
            detailsTotal: total,
            loading: false,
            error: null,
            lastSyncDt: new Date().getTime(),
            ot_details,
        };
    },

    [Types.FETCH_OT_DETAILS_FAILURE]: (state, action) => {
        return {
            ...state,
            loading: false,
            error: action.error,
            details: [],
        };
    },

    // Create an ot detail
    [Types.CREATE_OT_DETAIL]: (state, action) => {
        return {
            ...state,
            loading: true,
            error: null,
            otDetailCreated: null,
        };
    },

    [Types.CREATE_OT_DETAIL_SUCCESS]: (state, { detail, ot_details }) => {
        return {
            ...state,
            loading: false,
            otDetailCreated: detail,
            ot_details,
            error: null,
        };
    },

    [Types.CREATE_OT_DETAIL_FAILURE]: (state, { error }) => {
        return {
            ...state,
            loading: false,
            error,
            otDetailCreated: null,
        };
    },

    // Update an ot detail
    [Types.UPDATE_OT_DETAIL]: (state, action) => {
        return {
            ...state,
            loading: true,
            error: null,
            otDetailUpdated: null,
            otUpdatedDt: null,
        };
    },

    [Types.UPDATE_OT_DETAIL_SUCCESS]: (state, { detail, ot_details }) => {
        return {
            ...state,
            loading: false,
            otDetailUpdated: detail,
            otUpdatedDt: (new Date()).getTime(),
            ot_details,
            error: null,
        };
    },

    [Types.UPDATE_OT_DETAIL_FAILURE]: (state, { error }) => {
        return {
            ...state,
            loading: false,
            error,
            otDetailUpdated: null,
            otUpdatedDt: null,
        };
    },

    // Delete an existing detail
    [Types.DELETE_OT_DETAIL]: (state) => {
        return {
            ...state,
            loading: true,
            error: null,
        };
    },

    [Types.DELETE_OT_DETAIL_SUCCESS]: (state, { ot_details }) => {
        return {
            ...state,
            loading: false,
            error: null,
            ot_details,
        };
    },

    [Types.DELETE_OT_DETAIL_FAILURE]: (state, action) => {
        return {
            ...state,
            loading: false,
            error: action.error,
        };
    },

    /** Transactions */
    [Types.FETCH_OT_TRANSACTIONS]: (state) => {
        return {
            ...state,
            loading: true,
            error: null,
            transactions: [],
        };
    },

    [Types.FETCH_OT_TRANSACTIONS_SUCCESS]: (state, { transactions, total }) => {
        return {
            ...state,
            transactions,
            transactionsTotal: total,
            loading: false,
            error: null,
        };
    },

    [Types.FETCH_OT_TRANSACTIONS_FAILURE]: (state, { error }) => {
        return {
            ...state,
            loading: false,
            error: error,
            transactions: [],
        };
    },

    // Create an ot detail
    [Types.CREATE_OT_TRANSACTION]: (state, action) => {
        return {
            ...state,
            loading: true,
            error: null,
            otTransactionCreated: null,
        };
    },

    [Types.CREATE_OT_TRANSACTION_SUCCESS]: (state, { transactions }) => {
        return {
            ...state,
            loading: false,
            otTransactionCreated: transactions,
            error: null,
        };
    },

    [Types.CREATE_OT_TRANSACTION_FAILURE]: (state, { error }) => {
        return {
            ...state,
            loading: false,
            error,
            otTransactionCreated: null,
        };
    },

    // Delete an existing detail
    [Types.DELETE_OT_TRANSACTION]: (state) => {
        return {
            ...state,
            loading: true,
            error: null,
        };
    },

    [Types.DELETE_OT_TRANSACTION_SUCCESS]: (state) => {
        return {
            ...state,
            loading: false,
            error: null,
        };
    },

    [Types.DELETE_OT_TRANSACTION_FAILURE]: (state, { error }) => {
        return {
            ...state,
            loading: false,
            error: error,
        };
    },

    /** Assets */
    [Types.FETCH_OT_ASSETS]: (state) => {
        return {
            ...state,
            loading: true,
            error: null,
            assets: [],
        };
    },

    [Types.FETCH_OT_ASSETS_SUCCESS]: (state, { assets, total }) => {
        return {
            ...state,
            assets,
            loading: false,
            error: null,
        };
    },

    [Types.FETCH_OT_ASSETS_FAILURE]: (state, { error }) => {
        return {
            ...state,
            loading: false,
            error: error,
            assets: [],
        };
    },

    // Create an ot detail
    [Types.CREATE_OT_ASSET]: (state, action) => {
        return {
            ...state,
            loading: true,
            error: null,
        };
    },

    [Types.CREATE_OT_ASSET_SUCCESS]: (state, { asset }) => {
        return {
            ...state,
            loading: false,
            asset,
            error: null,
        };
    },

    [Types.CREATE_OT_ASSET_FAILURE]: (state, { error }) => {
        return {
            ...state,
            loading: false,
            error,
        };
    },

    // Delete an existing detail
    [Types.DELETE_OT_ASSET]: (state) => {
        return {
            ...state,
            loading: true,
            error: null,
        };
    },

    [Types.DELETE_OT_ASSET_SUCCESS]: (state) => {
        return {
            ...state,
            loading: false,
            error: null,
        };
    },

    [Types.DELETE_OT_ASSET_FAILURE]: (state, { error }) => {
        return {
            ...state,
            loading: false,
            error: error,
        };
    },

    // Create an work order
    [Types.CREATE_QUOTE]: (state, action) => {
        return {
            ...state,
            loading: true,
            error: null,
            otCreated: null,
        };
    },

    [Types.CREATE_QUOTE_SUCCESS]: (state, { quote }) => {
        return {
            ...state,
            loading: false,
            otCreated: quote,
            error: null,
            createdOtDt: new Date().getTime(),
        };
    },

    [Types.CREATE_QUOTE_FAILURE]: (state, { error }) => {
        return {
            ...state,
            loading: false,
            error,
            otCreated: null,
        };
    },


    // Notify customer with quote info
    [Types.NOTIFY]: (state) => {
        return {
            ...state,
            loading: true,
            error: null,
            lastNotifiedDt: null,
        };
    },

    [Types.NOTIFY_SUCCESS]: (state) => {
        return {
            ...state,
            loading: false,
            error: null,
            lastNotifiedDt: new Date().getTime(),
        };
    },

    [Types.NOTIFY_FAILURE]: (state, { error }) => {
        return {
            ...state,
            loading: false,
            error,
            lastNotifiedDt: null,
        };
    },

    /** Transactions */
    [Types.FETCH_OT_DISCOUNTS]: (state) => {
        return {
            ...state,
            loading: true,
            error: null,
            discounts: [],
        };
    },

    [Types.FETCH_OT_DISCOUNTS_SUCCESS]: (state, { discounts, total }) => {
        return {
            ...state,
            discounts,
            discountsTotal: total,
            loading: false,
            error: null,
        };
    },

    [Types.FETCH_OT_DISCOUNTS_FAILURE]: (state, { error }) => {
        return {
            ...state,
            loading: false,
            error: error,
            discounts: [],
        };
    },

    // Create an ot detail
    [Types.CREATE_OT_DISCOUNT]: (state, action) => {
        return {
            ...state,
            loading: true,
            error: null,
        };
    },

    [Types.CREATE_OT_DISCOUNT_SUCCESS]: (state, { discounts }) => {
        return {
            ...state,
            loading: false,
            error: null,
        };
    },

    [Types.CREATE_OT_DISCOUNT_FAILURE]: (state, { error }) => {
        return {
            ...state,
            loading: false,
            error,
        };
    },

    // Delete an existing detail
    [Types.DELETE_OT_DISCOUNT]: (state) => {
        return {
            ...state,
            loading: true,
            error: null,
        };
    },

    [Types.DELETE_OT_DISCOUNT_SUCCESS]: (state) => {
        return {
            ...state,
            loading: false,
            error: null,
        };
    },

    [Types.DELETE_OT_DISCOUNT_FAILURE]: (state, { error }) => {
        return {
            ...state,
            loading: false,
            error: error,
        };
    },

    // Create an ot attr
    [Types.FETCH_OT_ATTRIBUTES]: (state) => {
        return {
            ...state,
            loading: true,
            error: null,
            attributes: [],
        };
    },

    [Types.FETCH_OT_ATTRIBUTES_SUCCESS]: (state, { attributes }) => {
        return {
            ...state,
            attributes,
            loading: false,
            error: null,
        };
    },

    [Types.FETCH_OT_ATTRIBUTES_FAILURE]: (state, { error }) => {
        return {
            ...state,
            loading: false,
            error: error,
            attributes: [],
        };
    },

    [Types.CREATE_OT_ATTRIBUTE]: (state, action) => {
        return {
            ...state,
            loading: true,
            error: null,
            otAttributeCreated: null,
        };
    },

    [Types.CREATE_OT_ATTRIBUTE_SUCCESS]: (state, { transactions }) => {
        return {
            ...state,
            loading: false,
            otAttributeCreated: transactions,
            error: null,
        };
    },

    [Types.CREATE_OT_ATTRIBUTE_FAILURE]: (state, { error }) => {
        return {
            ...state,
            loading: false,
            error,
            otAttributeCreated: null,
        };
    },

    // Delete an existing detail
    [Types.DELETE_OT_ATTRIBUTE]: (state) => {
        return {
            ...state,
            loading: true,
            error: null,
        };
    },

    [Types.DELETE_OT_ATTRIBUTE_SUCCESS]: (state) => {
        return {
            ...state,
            loading: false,
            error: null,
        };
    },

    [Types.DELETE_OT_ATTRIBUTE_FAILURE]: (state, { error }) => {
        return {
            ...state,
            loading: false,
            error: error,
        };
    },

    // Create an ot detail
    [Types.CREATE_QUICK_QUOTE]: (state, action) => {
        return {
            ...state,
            loading: true,
            error: null,
        };
    },

    [Types.CREATE_QUICK_QUOTE_SUCCESS]: (state, { quote }) => {
        return {
            ...state,
            loading: false,
            error: null,
            createdQuote: quote,
        };
    },

    [Types.CREATE_QUICK_QUOTE_FAILURE]: (state, { error }) => {
        return {
            ...state,
            loading: false,
            error,
        };
    },

    // Create an ot detail
    [Types.CREATE_QUICK_OT]: (state, action) => {
        return {
            ...state,
            loading: true,
            error: null,
        };
    },

    [Types.CREATE_QUICK_OT_SUCCESS]: (state, { ot }) => {
        return {
            ...state,
            loading: false,
            error: null,
            createdOt: ot,
        };
    },

    [Types.CREATE_QUICK_OT_FAILURE]: (state, { error }) => {
        return {
            ...state,
            loading: false,
            error,
        };
    },

    [Types.RESET_CREATED_OT]: (state, {}) => {
        return {
            ...state,
            loading: false,
            error: null,
            createdOt: null,
        };
    },

    [Types.RESET_CREATED_QUOTE]: (state, {}) => {
        return {
            ...state,
            loading: false,
            error: null,
            createdQuote: null,
        };
    },

    // Update an work order
    [Types.CONFIRM_QUOTE]: (state, action) => {
        return {
            ...state,
            loading: true,
            error: null,
            ot: null,
            otUpdated: null,
        };
    },

    [Types.CONFIRM_QUOTE_FAILURE]: (state, action) => {
        return {
            ...state,
            loading: false,
            error: action.error,
        };
    },
});



// WEBPACK FOOTER //
// ./src/Redux/OtRedux.js